import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import DaysList from '../components/DaysList'
import Button from '../elements/Button'
import FormHOC from './FormHOC'
import { TimePicker } from '@material-ui/pickers'
import moment from 'moment'
import CustomTimePicker from '../components/CustomTimePicker'

const options = {
    postUrl: '/api/postUpdateQuietTimeSchedule',
    success: 'Scheduling successfully updated.',
    dontScrollToNav: true,
    showHideIcon: true
}

const state = {

}

const mapDays = {
    sunday: 'Sun',
    monday: 'Mon',
    tuesday: 'Tue',
    wednesday: 'Wed',
    thursday: 'Thu',
    friday: 'Fri',
    saturday: 'Sat'
}

const QuietTimeSchedulingForm = (props) => {
    const [isShowForm, setIsShowForm] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        // Hack: The form was pre-expanded after deleting the item above so added this as a quick fix
        setIsShowForm(false)
    }, [props.items])

    useEffect(() => {
        if (props.isNew) {
            setIsShowForm(true)
        }
    }, [])

    const handleChangeDay = day => {
        let newDays = []
        if (props.values.days) {
            newDays = [...props.values.days]
        }

        if (props.values.days && props.values.days.includes(day)) {
            newDays.splice(props.values.days.indexOf(day), 1)
        } else {
            newDays.push(day)
        }

        props.setDynamicValues({
            days: sortDays(newDays)
        })
    }

    // Update the array before we send it off to the API
    const handleSubmit = event => {
        event.preventDefault()
        const items = [...props.items]
        items[props.itemKey] = {
            startTime: props.values.startTime,
            endTime: props.values.endTime,
            days: props.values.days
        }

        props.setDynamicValues({
            serviceId: props.values.serviceId,
            startTime: convertMomentToTime(props.values.startTime),
            endTime: convertMomentToTime(props.values.endTime),
            days: props.values.days,
            scheduleItems: items
        }, () => {
            props.handleSubmit()
        })
    }

    const handleToggleForm = event => {
        event.preventDefault()
        // If its a new item and they havent added any days yet then delete it
        if (props.isNew) {
            props.handleDeleteItem(props.itemKey)
        }
        setIsShowForm(!isShowForm)
    }

    const handleDeleteItem = event => {
        event.preventDefault()
        props.handleDeleteItem(props.itemKey)
    }

    const hasErrors = name => {
        return props.errors && props.errors[name]
    }

    const showDays = () => {
        if (props.values.days) {
            return props.values.days.map((item, key) => {
                return <span key={key}>{key > 0 ? ' / ' : ''}{mapDays[item]}</span>
            })
        }
    }

    const sortDays = daysArr => {
        const days = { sunday: 0, monday: 1, tuesday: 2, wednesday: 3, thursday: 4, friday: 5, saturday: 6 }
        const startDay = 1 // Sunday

        return daysArr.sort(function (a, b) {
            return (days[a] < startDay ? days[a] + 7 : days[a]) -
                (days[b] < startDay ? days[b] + 7 : days[b])
        })
    }

    const convertMomentToTime = time => {
        if (time && typeof time === 'object') {
            return time.format('HH:mm')
        }

        return time
    }

    const convertTimeToMoment = time => {
        if (time && typeof time !== 'object') {
            const day = moment()
            const splitTime = time.split(/:/)

            return day.hours(parseInt(splitTime[0])).minutes(parseInt(splitTime[1])).seconds(0).milliseconds(0)
        }

        return time
    }

    return (
        <div className='quiet-time-schedule-form'>
            <div className={isShowForm ? 'd-none' : 'd-flex align-items-center'}>
                <div className='w-75'>
                    <p className='m-0 mb-2'>{convertMomentToTime(props.values.startTime)} to {convertMomentToTime(props.values.endTime)}</p>
                    <p className='m-0'>
                        {showDays()}
                    </p>
                </div>
                <div className='w-25 text-center'>
                    <a href='#' className='font-small' onClick={handleToggleForm}>edit</a>
                </div>
            </div>
            <form onSubmit={handleSubmit} className={isShowForm ? 'd-block' : 'd-none'}>
                <div className='py-2'>
                    <div className='d-flex mb-3'>
                        <div className='mr-2 w-50'>
                            <p className='font-small sub-bold m-0 mb-1'>Start</p>
                            <TimePicker
                                value={convertTimeToMoment(props.values.startTime)}
                                onChange={value => props.setDynamicValues({ startTime: convertMomentToTime(value) })}
                                ampm={false}
                                minutesStep='5'
                            />
                        </div>
                        <div className='w-50'>
                            <p className='font-small sub-bold m-0 mb-1'>End</p>
                            <CustomTimePicker
                                value={convertTimeToMoment(props.values.endTime)}
                                handleChange={value => {
                                    const minTime = moment(props.values.startTime, 'HH:mm')
                                    if (minTime.isBefore(value)) {
                                        props.setDynamicValues({ endTime: convertMomentToTime(value) })
                                        setError('')
                                    } else {
                                        setError('The end time must be greater than the start time')
                                    }
                                }}
                                errorMessage={error}
                            />
                        </div>
                    </div>
                    <div className='mb-3'>
                        <p className={`font-small sub-bold m-0 mb-1 ${hasErrors('days') ? 'color-red' : ''}`}>Select days</p>
                        <div className='d-flex'>
                            <DaysList
                                handleClick={handleChangeDay}
                                selectedDays={props.values.days}
                            />
                        </div>
                    </div>
                    {props.children ? <div className='mb-3'>{props.children}</div> : ''}
                    <div className='d-flex align-items-center'>
                        <div className='w-50'>
                            <a href='#' onClick={handleDeleteItem} className='d-block'>
                                <img src='/images/icon-trash.svg' alt='Delete' title='Delete' width='35px' className='do-animate-rollover' />
                            </a>
                        </div>
                        <div className='d-flex w-50 justify-content-end align-items-center'>
                            <div className='mr-3'>
                                <a href='#' onClick={handleToggleForm} className='font-small'>Cancel</a>
                            </div>
                            <Button title='Save' action={handleSubmit} />
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}

QuietTimeSchedulingForm.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    isEnabled: PropTypes.bool.isRequired,
    isNew: PropTypes.bool,
    items: PropTypes.array.isRequired,
    itemKey: PropTypes.number.isRequired,
    handleDeleteItem: PropTypes.func.isRequired
}

export default FormHOC(QuietTimeSchedulingForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/QuietTimeSchedulingForm.js